import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Switch } from "./ui/switch";
import client, { apiErr } from "../lib/api";
import { currentSub } from "../lib/push";

const LABELS = {
  signals: ["Naye signals", "Telegram signal, chart analysis, blog"],
  news: ["News & events", "Badi news se 15 min pehle + result"],
  leads: ["Nayi leads", "Lead aane ya assign hone par"],
  followups: ["Follow-up reminders", "Follow-up ka time hone par"],
  summary: ["Subah-shaam summary", "10 AM aur 9 PM ka report"],
};

export function PushPrefs({ open, onOpenChange, onTurnOff }) {
  const [prefs, setPrefs] = useState(null);

  useEffect(() => {
    if (!open) {
      return;
    }
    currentSub().then((s) => s && client.post("/push/prefs", { endpoint: s.endpoint }))
      .then((r) => r && setPrefs(r.data)).catch((e) => toast.error(apiErr(e)));
  }, [open]);

  const flip = async (t) => {
    const next = prefs.topics.includes(t) ? prefs.topics.filter((x) => x !== t) : [...prefs.topics, t];
    setPrefs({ ...prefs, topics: next });
    try {
      const s = await currentSub();
      const { data } = await client.post("/push/prefs", { endpoint: s.endpoint, topics: next });
      setPrefs(data);
    } catch (e) { toast.error(apiErr(e)); }
  };
  const test = async () => {
    try { await client.post("/push/test"); toast.success("Test alert bheja — phone check karein"); }
    catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="push-prefs-dialog" className="max-w-sm border-[color:var(--border-subtle)]" style={{ background: "var(--surface)" }}>
        <DialogHeader><DialogTitle className="font-head text-white">Phone alerts</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-400 -mt-2">Is phone pe kaun se alerts aayein, wo chuniye.</p>
        <div className="space-y-1">
          {(prefs?.available || []).map((t) => (
            <label key={t} className="flex items-center gap-3 px-3 py-2.5 border border-[color:var(--border-subtle)] cursor-pointer hover:bg-white/5 transition-colors duration-200">
              <div className="flex-1">
                <div className="text-sm text-white">{LABELS[t][0]}</div>
                <div className="text-[11px] text-slate-500">{LABELS[t][1]}</div>
              </div>
              <Switch data-testid={`push-pref-${t}`} checked={prefs.topics.includes(t)} onCheckedChange={() => flip(t)} />
            </label>
          ))}
          {!prefs && <div className="text-xs text-slate-500 py-4 text-center">Loading…</div>}
        </div>
        <div className="flex gap-2 pt-2">
          <button data-testid="push-test-btn" onClick={test} className="flex-1 py-2 text-xs font-bold bg-gold text-black hover:brightness-110 transition-[filter] duration-200">Test alert</button>
          <button data-testid="push-off-btn" onClick={onTurnOff} className="flex-1 py-2 text-xs border border-[color:var(--border-subtle)] text-slate-300 hover:text-bear transition-colors duration-200">Alerts band karein</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
